export default function Sleep(milliseconds) {
    return new Promise((resolve, reject) => {
        window.setTimeout(() => resolve(), milliseconds)
    })
}
